// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* * * * * * * * * * * * * * *\n\t\tdisplay sizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tsizes\n* * * * * * * * * * * * * * */\n/* * * * * * * * * * * * * * *\n\t\tcolors\n* * * * * * * * * * * * * * */\n/* fonts */\n/* borders */\n/* rest */\n/* new colors */\n.root__SystemInfo_1lTVJ {\n  width: 100%;\n  height: 20px;\n  z-index: 10000;\n  background-color: #25aae1;\n  padding-left: 20px;\n}\n.root__SystemInfo_1lTVJ p {\n  color: white;\n  font-size: 12px;\n  letter-spacing: 1px;\n}\n.root__SystemInfo_1lTVJ p a {\n  color: #000000;\n}\n", ""]);
// Exports
exports.locals = {
	"root": "root__SystemInfo_1lTVJ"
};
module.exports = exports;
